import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  ICloseReturnObject,
  ICloseReturnType,
  PlaceholderChildComponent
} from "@ispm/layout/classes/placeholder-child-component.abstract";
import {modalResponse} from "@ispm/layout/constants/modal-responses.enum";
import {Widget} from "@ispm/widgets/decorator/widget.decorator";
import {IWidgetItem} from "@ispm/widgets/interfaces/widget-item.interface";
import {IEvent} from "@ispm-client/modules/events/Interfaces";

@Component({
  selector: 'ispm-general-dialog',
  templateUrl: './general-dialog.component.html',
  styleUrls: ['./general-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('GeneralDialog')
export class GeneralDialogComponent extends PlaceholderChildComponent implements OnInit,IWidgetItem{
  public data: any;

  set widgetData(widgetData: any) {
    this.data = widgetData;
  }

  set widgetConfig(config: any) {
    this.payload = config.widgetPayload;
  }

  constructor() {
    super();
  }

  ngOnInit() {
  }

  beforeClose(_modalResponse?: modalResponse): void | ICloseReturnType {
    return undefined;
  }

}
